// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__fqtdQ"};
module.exports.__checksum = "fd68782e8686"